// extracted by mini-css-extract-plugin
module.exports = {"new":"view-default_new_3-ey6","dangerous":"view-default_dangerous_15DvA"};